import React from 'react';
import PropTypes from 'prop-types';
import { Grid, useMediaQuery, useTheme, Paper } from '@mui/material';

import Split from 'react-split'; // For split panels. Documentation: https://github.com/nathancahill/split/tree/master/packages/splitjs#sizes

import AssetDetailsHeader from './AssetDetailsHeader';
import AssetExpansionDetails from './AssetExpansionDetails';

import AssetReferencesPane from './AssetReferencesPane';
import AssetViewer from '../AssetViewer/AssetViewer';

const AssetDetails = ({ asset }) => {
  const viewType = 'AssetDetailsView';

  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.down('md')); // Used for type of JSX returned
  const { assetMasterContent, rendition_content: renditionContent } = asset;
  const hasFilesAndPreview =
    Object.keys(assetMasterContent).length > 0 &&
    Object.keys(renditionContent).length > 0;

  return !hasFilesAndPreview ? (
    <>
      <AssetDetailsHeader asset={asset} />

      <AssetExpansionDetails
        asset={asset}
        buttonGroupProps={{ buttons: ['download', 'graph'] }}
        detailsProps={{ disableAccordion: true }}
      />
    </>
  ) : (
    <>
      <AssetDetailsHeader asset={asset} />

      <Paper square>
        {!isMedium && (
          <Split
            className="split"
            minSize={[600, 100]}
            sizes={[90, 10]}
            gutterSize={12}
            gutterAlign="center"
            style={{ display: 'flex', paddingBottom: '24px' }}
          >
            <div style={{ padding: '6px' }}>
              <AssetViewer asset={asset} viewType={viewType} />
            </div>
            <div style={{ padding: '6px' }}>
              <AssetExpansionDetails
                asset={asset}
                buttonGroupProps={{ buttons: ['download', 'graph'] }}
                detailsProps={{ disableAccordion: true }}
              />
            </div>
          </Split>
        )}

        {isMedium && (
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="stretch"
            spacing={1}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={8}
              xl={8}
              style={{ paddingBottom: '24px', minHeight: '800px' }}
            >
              <AssetViewer asset={asset} viewType={viewType} />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={4}
              xl={4}
              style={{ paddingBottom: '24px' }}
            >
              <AssetExpansionDetails
                asset={asset}
                buttonGroupProps={{ buttons: ['download', 'graph'] }}
                detailsProps={{ disableAccordion: true }}
              />
            </Grid>
          </Grid>
        )}

        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <AssetReferencesPane asset={asset} />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

AssetDetails.propTypes = {
  asset: PropTypes.object.isRequired,
};

export default AssetDetails;
